import { gql } from "@apollo/client";

export default gql`
  mutation banWorker($data: BanWorkerInput!) {
    banWorker(data: $data) {
      workerId
    }
  }
`;
